// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8b4b6c80","239":"12170707","453":"153072c4","732":"004f67f4"}[chunkId] + ".chunk.js";
};